module.exports = __webpack_public_path__ + "static/media/ordini7.ca66c61d.png";